<template>
  <div class="container-fluid mt-2">
    <h2>Aktions Code</h2>
    <div class="btn-toolbar justify-content-between" role="toolbar">
      <button @click="saveCard"   class="btn btn-primary">Speichern</button>
      <button @click="updateStatus(1)" class="btn btn-success">Aktion starten</button>
      <button @click="updateStatus(3)" class="btn btn-secondary">Aktion Beenden</button>
      <button @click="updateStatus(2)" class="btn btn-danger">Aktion abbrechen</button>
    </div>
    <b-tabs class="mt-3">
      <b-tab title="Allgemein">
        <div class="row mt-2">
          <div class="col">
            <div class="form-group">
              <label>Titel / Name</label>
              <input type="text" v-model="card.title" class="form-control"/>
            </div>
            <div class="form-group">
              <label>Beschreibung</label>
              <textarea class="form-control" v-model="card.description">
              </textarea>
            </div>
            <div class="form-group">
              <label>Kontakt E-Mail</label>
              <input type="text" class="form-control" v-model="card.contact"/>
            </div>
            <div class="form-group">
              <label>Status</label>
              <div v-if="card.status == 0" class="alert alert-secondary">
                NEU
              </div>
              <div v-else-if="card.status == 1" class="alert alert-success">
                AKTIV
              </div>
              <div v-else-if="card.status == 2" class="alert alert-danger">
                ABGEBROCHEN
              </div>
              <div v-else-if="card.status == 3" class="alert alert-primary">
                BEENDET
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Aktions Code</label>
              <input type="text" class="form-control" v-model="card.code"/>
            </div>
            <div class="form-group">
              <label>Geplanter Start</label>
              <DateInput v-model="startDate"/>
            </div>
            <div class="form-group">
              <label>Geplantes Ende</label>
              <DateInput v-model="endDate"/>
            </div>
            <div class="form-group">
              <label>Rabatt</label>
              <input type="number" class="form-control" v-model="card.priceInfo.Rabatt"/>
            </div>
            <h5>Verkaufskan&auml;le</h5>
            <div class="row">
              <div class="col">
                <div class="form-check">
                  <input type="checkbox" v-model="card.bshop" class="form-check-input" id="bshopflag"/>
                  <label for="bshopflag">bShop</label>
                </div>
              </div>
              <div class="col">
                <div class="form-check">
                  <input type="checkbox" v-model="card.ihand" class="form-check-input" id="ihandflag"/>
                  <label for="ihandflag">iHand</label>
                </div>
              </div>
              <div class="col">
                <div class="form-check">
                  <input type="checkbox" v-model="card.ifair" class="form-check-input" id="ifairflag"/>
                  <label for="ifairflag">iFair</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab title="Einstellungen">
        <div class="row">
          <div class="col">
            <h5>Einstellungen</h5>
            <div class="form-check">
              <input type="checkbox" v-model="card.multiUsage" id="multiuse" class="form-check-input"/>
              <label for="multiuse">Mehrfach Verwendung</label>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-check">
                  <input type="checkbox" v-model="card.allCustomer" id="allcustomer" class="form-check-input"/>
                  <label for="allcustomer">Alle Kunden</label>
                </div>
                <div class="form-group">
                  <label>Kundengruppen</label>
                  <select v-model="card.customerGroups" multiple size="8" class="form-control">
                    <option v-for="(item,index) in customergroups" :key="index" :value="item.group">{{ item.group }}</option>
                  </select>
                </div>
              </div>
              <div class="col">
                <div class="form-check">
                  <input type="checkbox" id="allarticle" v-model="card.allArticle" class="form-check-input"/>
                  <label for="allarticle">Alle Artikel</label>
                </div>
                <div class="form-group">
                  <label>Artikelsortimente</label>
                  <select v-model="card.selections" multiple size="8" class="form-control">
                    <option v-for="item in articlesels" :key="item.map_id" :value="item.map_id">{{ item.name }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <h5>Preisinfos</h5>
            <div class="row">
              <div class="col">
                <strong>Name</strong>
              </div>
              <div class="col">
                <strong>Wert</strong>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <input type="text" class="form-control" v-model="priceKey">
              </div>
              <div class="col">
                <div class="input-group">
                  <input type="text" v-model="priceVal" class="form-control"/>
                  <div class="input-group-append">
                    <button @click="addPriceInfo" class="btn btn-primary"><font-awesome-icon icon="plus"/></button>
                  </div>
                </div>
              </div>
            </div>
            <!-- price info content -->
            <div class="row" v-for="(val,key) in card.priceInfo" :key="key">
              <div class="col">
                <input type="text" disabled :value="key" class="form-control"/>
              </div>
              <div class="col">
                <div class="input-group">
                  <input type="text" disabled :value="val" class="form-control"/>
                  <div class="input-group-append">
                    <button @click="remPriceInfo(key)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
                  </div>
                </div>
              </div>
            </div>
            <!-- price info parameter documentation for users -->
            <div class="row mt-2">
              <div class="col">
                <h5>Parameter Infos</h5>
                <div class="container-fluid" v-html="paramDocs">
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab title="Validierung">
        <div class="row">
          <div class="col">
            <h5>Gültigkeitsregeln</h5>
            <div class="wrapper" style="width:100%;height:200px;">
              <AceEditor ref="ruleEditor" editorId="ruleEditor" lang="javascript" :content="ruleScript"/>
            </div>
          </div>
          <div class="col">
            <h5>Dokumentation</h5>
            Jede Aktion wird bei einer Bestellung bei Auswahl und beim übermitteln geprüft. Dazu wird folgendes Abgeglichen:
            <ul>
              <li>Die Aktion ist als "aktiv" eingetragen</li>
              <li>Prüfzeitpunkt liegt innerhalb vom geplanten Start- und Endedatum</li>
              <li>Die Aktion gilt für alle Kunden, oder der aktive Kunde ist in einer der zur Aktion gehörenden Kundengruppen</li>
              <li>Die Artikel die Rabatt bekommen sind Teil der vorgegebenen Sortimente oder es ist das Flag "Alle Artikel" ausgewählt.</li>
            </ul>
            Möchten Sie weitere Einschränkungen oder Prüfungen zur Aktivierung eines Aktionscodes, können diese Regeln hier als Script Funktion hinterlegt werden.
            <pre>
              function checkCode(submit) {
                ...
              }
            </pre>
            <p>
              Der Parameter <i>submit</i> ist true wenn der Code aktiviert werden soll und die Bestellung versendet wird. Andernfalls bei einer Aktivierung im Warenkorb oder beim Vertreter vor der Übermittlung immer "false". (z.B. Prüfung Mindestbestellwert nur bei submit = true).
            </p>
            <p>
              Das entsprechende Dokument zur Analyse ist im Skript Kontext unter "param" erreichbar.
            </p>
            <p>
              Als Rückgabe sollte die Funktion ein JSONObject zurück geben, mit einem entsprechenden Fehlertext unter einem Attribute "error" oder "success":true bei erfolgreicher Prüfung.
            </p>
          </div>
        </div>
      </b-tab>
      <b-tab title="Statistik-Erhebung">
        <div class="row">
          <div class="col">
            <h5>Statistik-Sammlung</h5>
            <div class="wrapper" style="width:100%;height:200px;">
              <AceEditor ref="statEditor" editorId="statEditor" lang="javascript" :content="statScript"/>
            </div>
          </div>
          <div class="col">
            <h5>Dokumentation</h5>
            <p>
              Nach der Übermittlung wird jeder Code mit einem Eintrag versehen, das er benutzt wurde. Um hier aus der Tabelle auch schon feinere Statistiken erstellen zu können, ohne alle Bestellhistorien erneut zu laden,
              kann ein Script zum auslesen gewünschter Attribute erstellt werden.
            </p>
            <p>
              Das entsprechende Dokument zur Analyse ist im Skript Kontext unter "param" erreichbar.
            </p>
            <pre>
              function statUsage() {
                ...
              }
            </pre>
            <p>
              Als Rückgabe wird ein JSONObject erwartet, welches an den Statistik Eintrag der Übermittlung angehängt wird.
            </p>
          </div>
        </div>
      </b-tab>
      <b-tab title="Aktivitäten">
        <h5 class="mt-3">Genutzte Codes</h5>
        <div class="btn-toolbar">
          <div class="form-inline">
            <label class="mr-2">von</label>
            <DateInput @input="updateCounter" v-model="filterStart"/>
          </div>
          <div class="form-inline">
            <label class="ml-2 mr-2">bis</label>
            <DateInput @input="updateCounter" v-model="filterEnd"/>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col">
            <table class="table table-striped">
              <thead>
                <th>Datum</th>
                <th>Angewendet</th>
              </thead>
              <tbody>
                <tr v-for="item in usageData" :key="item.date">
                  <td>{{ item.date }}</td>
                  <td>{{ item.count }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import config    from '@/modules/config.js'
import articles  from '@/modules/articles.js'
import customers from '@/modules/customers.js'
import giftcards from '@/modules/giftcards.js'
import DateInput from '@/components/common/DateInput.vue'
import AceEditor from '@/components/AceEditor.vue'

export default {
  name: 'GiftCardEditor',
  components: {
    AceEditor,
    DateInput
  },
  data() {
    return {
      card: { priceInfo:{}, ruleInfo: {},multiUsage:false,allArticle: true,allCustomer: true , customerGroups: [], selections: [] },
      endDate: new Date(),
      startDate: new Date(),
      statScript: '',
      ruleScript: '',
      priceVal: '',
      priceKey: '',
      customergroups: [],
      articlesels: [],
      filterStart: new Date(),
      filterEnd: new Date(),
      usageData: [],
      paramDocs: '',
    }
  },
  created: function() {
    var self = this;
    config.loadcfg(["giftcard.params.readme"],this,function(data) {
      self.paramDocs = data['giftcard.params.readme'];
    });
    // init customer groups list
    customers.listgroups(this,function(data) {
      if (data) {
        self.customergroups = data;
      }
    });
    // artikel sortimente laden
    articles.searchSelections(this,0,1000,false,function(data) {
      if (data) {
        self.articlesels = data;
      }
    });
    // check to load main entry
    if (this.$route.params.id !== 'new') {
      giftcards.load(this,this.$route.params.id,function(data) {
        self.card = data;
        self.card.priceInfo = data.priceInfo || {};
        self.startDate = new Date(data.start);
        self.endDate   = new Date(data.end);
        self.ruleScript = data.checkScript;
        self.statScript = data.statsScript;
      });
    }
  },
  methods: {
    updateCounter() {
      var self = this;
      giftcards.usageStat(this,this.card.map_id,this.filterStart,this.filterEnd,function(data) {
        self.usageData = data;
      })
    },
    addPriceInfo() {
      if (!this.priceKey || this.priceKey === '') {
        this.$bvToast.toast('Bitte zuerst ein Name für den Wert eingeben.',{title:'Preisinfos',variant: 'warning'});
        return;
      }
      if (!this.card.priceInfo) this.card.priceInfo = {};
      this.card.priceInfo[this.priceKey] = this.priceVal;
      this.priceKey = '';
      this.priceVal = '';
      this.$forceUpdate();
    },
    remPriceInfo(key) {
      delete this.card.priceInfo[key];
      this.$forceUpdate();
    },
    updateStatus(stat) {
      if (this.card.status == stat) return; // nothing to do
      this.card.status = stat;
      this.saveCard(true);
    },
    saveCard(sync) {
      var self = this;
      this.card.start = this.startDate.toISOString().substring(0,10) + ' 00:00:00';
      this.card.end   = this.endDate.toISOString().substring(0,10) + ' 00:00:00';
      this.card.statsScript = this.$refs.statEditor.getContent();
      this.card.checkScript  = this.$refs.ruleEditor.getContent();
      giftcards.save(this,this.card,sync,function(data) {
        if (data) {
          self.card = data;
          self.$bvToast.toast('Aktions Code gespeichert',{title: 'Aktions Code',variant: 'success'});
        }
      });
    }
  }
}
</script>
